const reviews = [
  {
    name: "James R.",
    location: "Houston, TX",
    stars: 5,
    text: "We lost power for 4 days after a hurricane. The solar generator from Iron Haven kept our fridge, lights, and medical devices running the whole time. Worth every penny.",
    avatar: "JR",
  },
  {
    name: "Carla M.",
    location: "Portland, OR",
    stars: 5,
    text: "Setup was incredibly simple and the team answered all my questions before I even ordered. My family feels so much safer knowing we have backup power.",
    avatar: "CM",
  },
  {
    name: "Derek T.",
    location: "Phoenix, AZ",
    stars: 5,
    text: "Switched from a gas generator — never going back. Quiet, clean, and it just works. The rolling blackouts in summer used to stress me out. Not anymore.",
    avatar: "DT",
  },
  {
    name: "Patricia N.",
    location: "Nashville, TN",
    stars: 5,
    text: "Iron Haven had the best prices I could find and the product arrived faster than expected. Their customer support actually knows what they\u2019re talking about.",
    avatar: "PN",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 bg-gray-950 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-3">
          <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-3">
            Trusted by homeowners looking for long-term peace of mind
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white">
            Trusted by Homeowners Nationwide
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400"></i>
              ))}
            </div>
            <span className="text-gray-400 text-sm">4.9 stars · 1,200+ customers and counting</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="bg-white/5 border border-white/10 rounded-lg p-5 flex flex-col gap-3 hover:border-amber-500/30 transition-colors"
            >
              <div className="flex items-center gap-1">
                {[...Array(r.stars)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                ))}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-2 border-t border-white/10">
                <div className="w-9 h-9 flex items-center justify-center bg-amber-500 rounded-full text-white text-xs font-bold shrink-0">
                  {r.avatar}
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">{r.name}</p>
                  <p className="text-gray-500 text-xs">{r.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
